<template>
	<div>
		<div class="home-btn d-none d-sm-block">
			<a href="/">
				<i class="mdi mdi-home-variant h2 text-white"></i>
			</a>
		</div>
		<div>
			<div class="container-fluid p-0">
				<div class="row no-gutters">
					<div class="col-lg-8">
						<div class="authentication-bg">
							<div class="bg-overlay"></div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
							<div class="w-100">
								<div class="row justify-content-center">
									<div class="col-lg-9">
										<div>
											<div class="text-center">
												<div>
													<img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" style="height: 40%; width: 40%;" />
												</div>
												<h4 class="font-size-18 mt-0">{{ $t('label.welcomeBack') }}</h4>
												<p class="text-muted">{{ $t('label.signInToContinueToProject', [$t('projectName')]) }}</p>
											</div>
											<div class="form-group mt-5">
												<div class="row mb-2">
													<div class="col-12">
														<p class="h6 mb-2">{{ $t('label.loginAs') }}</p>
													</div>
												</div>
												<div class="row">
													<div
														v-for="(item, index) in loginType"
														:key="index"
														class="col-6"
													>
														<div
															@click="!item.maintenance && (accountType = item.value)"
															:class="[
																'd-flex align-items-center justify-content-center rounded py-3 cursor-pointer position-relative overflow-hidden',
																accountType == item.value ? 'border border-info bg-soft-info text-white shadow shadow-lg' : 'border shadow text-muted'
															]"
															style="transition: 0.4s;"
														>
															<div
																v-if="item.maintenance"
																class="ribbon-wrapper"
															>
																<div class="ribbon font-weight-bold text-uppercase h6">
																	{{ $t('label.maintenance') }}
																</div>
															</div>
															<i
																:class="[
																	'mdi mr-2 font-size-28',
																	item.icon,
																	accountType == item.value ? 'text-info' : 'text-muted',
																]"
															></i>
															<div>
																<strong
																	:class="[
																		accountType == item.value ? 'text-info' : 'text-muted',
																	]"
																>
																	{{ item.text }}
																</strong>
																<small class="d-block text-muted">{{ item.description }}</small>
															</div>
															<i
																:class="[
																	'mdi mdi-check-circle ml-2 font-size-20',
																	accountType == item.value ? 'text-info' : 'text-white',
																]"
																style="transition: 0.4s;"
															></i>
														</div>
													</div>
												</div>
											</div>
											<div v-if="accountType" :key="accountType" class="py-2 mt-0 fade-in">
												<form class="form-horizontal" @submit.prevent="requestLogin">
													<div class="form-group auth-form-group-custom mb-4">
														<i
															:class="[
																'ri-mail-line auti-custom-input-icon',
																submitted && $v.loginForm.email.$error ? 'text-danger' : 'text-info',
															]"
														></i>
														<label for="email" :class="[submitted && $v.loginForm.email.$error ? 'text-danger' : 'text-info']">
															{{ $t('label.email') }}
														</label>
														<input
															type="email"
															v-model="loginForm.email"
															class="form-control" id="email"
															:placeholder="$t('label.enter', [$t('label.email')])"
															:class="{ 'is-invalid': submitted && $v.loginForm.email.$error }"
														/>
														<div v-if="submitted && $v.loginForm.email.$error" class="invalid-feedback text-right">
															<span v-if="!$v.loginForm.email.required">
																{{ $t('message.requiredX', [$t('label.email')]) }}
															</span>
															<span v-if="!$v.loginForm.email.email">
																{{ $t('message.validX', [$t('label.email')]) }}
															</span>
														</div>
													</div>
													<div class="form-group auth-form-group-custom mb-4">
														<i
															:class="[
																'ri-lock-2-line auti-custom-input-icon',
																submitted && !$v.loginForm.password.required ? 'text-danger' : 'text-info',
															]"
														></i>
														<label for="userpassword" :class="[submitted && !$v.loginForm.password.required ? 'text-danger' : 'text-info']">
															{{ $t('label.password') }}
														</label>
														<input
															v-model="loginForm.password"
															type="password"
															class="form-control"
															id="password"
															:placeholder="$t('label.enter', [$t('label.password')])"
															:class="{ 'is-invalid': submitted && $v.loginForm.password.$error }"
														/>
														<div v-if="submitted && !$v.loginForm.password.required" class="invalid-feedback text-right">
															{{ $t('message.requiredX', [$t('label.password')]) }}
														</div>
													</div>
													<div class="mt-4 text-center">
														<button
															class="btn btn-info w-md waves-effect waves-light col-12"
															type="submit"
														>
															{{ $t('label.login') }}
														</button>
													</div>
													<div class="mt-4 text-center">
														<router-link
															:to="accountType == 'admin' ? '/forgot-password?login=admin' : '/forgot-password?login=ihextar'"
															class="text-muted"
														>
															<i class="fas fa-lock mr-1"></i> {{ $t('label.forgotPassword') }}
														</router-link>
													</div>
												</form>
											</div>
											<div class="mt-5 text-center">
												<p>
													© {{ new Date().getFullYear() }} {{ $t('projectName') }}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import { sharedHelper } from '@/utils';
import i18n from "@/i18n";
import { mapState } from "vuex";
import store from '@/state/store';

let refresh = true;
export default {
	async created() {
		document.body.classList.add("auth-body-bg");

		await this.refreshCredential();
	},
	validations: {
		loginForm: {
			email: { required, email },
			password: { required },
		},
	},
	data() {
		return {
			submitted: false,
			loginType: [
				{ value: 'admin', text: i18n.t('label.admin'), description: 'Administration', icon: 'mdi-shield-account-outline', maintenance: false },
				{ value: 'ihextar', text: 'iHextar', description: 'Employee', icon: 'mdi-account-circle-outline', maintenance: false },
			],
			loginForm: {
				email: '',
				password: '',
				platform: sharedHelper.getPlatform(),
			},
			accountType: 'admin',
		};
	},
	methods: {
		requestLogin() {
			this.submitted = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				const namespace = this.accountType == 'admin' ? 'api/auth' : 'app/auth';

				this.$store.dispatch(`${namespace}/login`, {
					data: {
						...this.loginForm,
						password: this.loginForm.password,
					},
				});
			}
		},
		async refreshCredential() {
			if (refresh) return;
			refresh = true;
			await store.dispatch('api/auth/logout');
			await store.dispatch('app/auth/logout');
		},
	},
	computed: {
		...mapState('api/auth', { apiStatus: 'status' }),
		...mapState('app/auth', { appStatus: 'status' }),
	},
};
</script>
<style scope>
.ribbon-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
    z-index: 2;
}

.ribbon {
    position: absolute;
    top: 18px;
    right: -42px;
    width: 150px;
    transform: rotate(45deg);
    text-align: center;
    font-size: 0.62rem;
    line-height: 1.1;
    padding: 5px 0;
    color: #343a40;
    background: #f1f3f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}
</style>